import { useTranslation } from 'react-i18next';

import { formatVideoTimestampSeconds } from '../lib/formatVideoTimestamp';

interface Props {
  seconds: number;
}

/**
 * Shows which timeline position the pending video annotation will use (pinned or current playhead).
 */
export function VideoCommentComposerTimestampChip({ seconds }: Props) {
  const { t } = useTranslation('projects');

  const label = formatVideoTimestampSeconds(seconds);
  return (
    <span
      className="mt-px inline-flex shrink-0 items-center gap-1 rounded-md bg-warning px-2 py-1 text-xs font-normal leading-none text-warning-foreground select-none"
      title={t('commentOnFile.videoCommentComposerTimestampChip.annotationTimestamp', {
        timestamp: label,
      })}
      aria-label={t('commentOnFile.videoCommentComposerTimestampChip.annotationWillUseTimestamp', {
        timestamp: label,
      })}
    >
      {label}
    </span>
  );
}
